export default __webpack_public_path__ + "static/fileextreme-f259a14715d3e8704393fb3ad9eaf168.png";